
export class CleaupTool {

    public static cleanup() : void {
        alert('Ej implementerad ännu');
    }

}
